/**
 * @generated SignedSource<<a68226cabbe69a0c5a8e64570ea7eb6b>>
 * @relayHash a9a6ff7ce5608a37e6015262efbd9eb0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 152b79efc61eeb609ce8a5a54087c5bb0503ee8555503d7a710b12b620f1443b

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoveEventAttendanceInput = {
  clientMutationId?: string | null | undefined;
  eventId: string;
  userId?: string | null | undefined;
};
export type EventAttendContentRemoveAttendanceMutation$variables = {
  input: RemoveEventAttendanceInput;
};
export type EventAttendContentRemoveAttendanceMutation$data = {
  readonly removeEventAttendance: {
    readonly event: {
      readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonNew_event" | "EventAttendContent_event" | "EventEditAttendeesList_event" | "EventItemNew_event" | "EventScreenAttendeesDialogContent_event" | "EventScreenNewDesktop_event" | "EventScreenNewMobile_event">;
    } | null | undefined;
  } | null | undefined;
};
export type EventAttendContentRemoveAttendanceMutation = {
  response: EventAttendContentRemoveAttendanceMutation$data;
  variables: EventAttendContentRemoveAttendanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "status": {
        "notIn": [
          "NOT_ATTENDING",
          "PENDING_APPROVAL",
          "REJECTED"
        ]
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Literal",
    "name": "name",
    "value": ""
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SORT_ORDER_ASC",
      "CREATED_AT_ASC"
    ]
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v14 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v15 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v16 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v13/*: any*/),
            (v14/*: any*/),
            {
              "kind": "Literal",
              "name": "fo",
              "value": "face"
            },
            (v15/*: any*/),
            (v16/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v13/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentStatus",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = [
  (v3/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorPalette",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMe",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "kind": "Literal",
  "name": "filter",
  "value": {
    "status": {
      "in": [
        "ATTENDING_IN_PERSON",
        "ATTENDING_VIRTUAL",
        "WAITING_IN_PERSON",
        "WAITING_VIRTUAL"
      ]
    }
  }
},
v34 = [
  (v33/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v35 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v4/*: any*/),
              (v12/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v24/*: any*/)
    ],
    "storageKey": null
  }
],
v36 = {
  "kind": "Literal",
  "name": "filter",
  "value": {
    "status": {
      "in": [
        "WAITING_IN_PERSON",
        "WAITING_VIRTUAL"
      ]
    }
  }
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "presenter",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v4/*: any*/),
    (v12/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateProvinceRegionCode",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipPostalCode",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "geojson",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v47 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "ATTENDING_IN_PERSON"
    }
  },
  (v46/*: any*/)
],
v48 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v24/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v4/*: any*/),
              (v12/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "websiteUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitterUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagramUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linkedinUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "youtubeUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "githubUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blueskyUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v7/*: any*/),
  (v25/*: any*/)
],
v49 = [
  "condition"
],
v50 = [
  (v36/*: any*/),
  (v46/*: any*/)
],
v51 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "ATTENDING_VIRTUAL"
    }
  },
  (v46/*: any*/)
],
v52 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "NOT_ATTENDING"
    }
  },
  (v46/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventAttendContentRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventEditAttendeesList_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventAttendButtonNew_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventItemNew_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventAttendContent_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewMobile_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewDesktop_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenAttendeesDialogContent_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventAttendContentRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByName",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": (v6/*: any*/),
                                "concreteType": "EventTicketingTiersConnection",
                                "kind": "LinkedField",
                                "name": "eventTicketingTiers",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventTicketOrder",
                            "kind": "LinkedField",
                            "name": "ticketOrder",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalAmount",
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "purchaserUser",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTicketOrderItemsConnection",
                                "kind": "LinkedField",
                                "name": "eventTicketOrderItems",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventTicketOrderItem",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "attendeeFirstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "attendeeLastName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "managerVisibleAttendeeEmail",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "canResendTicketInvitationEmail",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "claimed",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "forPurchaser",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "attendeeUser",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventTicketingTier",
                                        "kind": "LinkedField",
                                        "name": "eventTicketingTier",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormSubmission",
                            "kind": "LinkedField",
                            "name": "formSubmission",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormFieldValuesConnection",
                                "kind": "LinkedField",
                                "name": "formFieldValuesBySubmissionId",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormFieldValue",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "value",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FormFieldSnapshot",
                                        "kind": "LinkedField",
                                        "name": "snapshot",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "label",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "fieldType",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "position",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "options",
                                            "storageKey": null
                                          },
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "eventAttendeesByName(filter:{\"status\":{\"notIn\":[\"NOT_ATTENDING\",\"PENDING_APPROVAL\",\"REJECTED\"]}},first:20,name:\"\")"
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": [
                  "name",
                  "filter"
                ],
                "handle": "connection",
                "key": "EventEditAttendeesList_event_eventAttendeesByName",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByName"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasVenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendee",
                "kind": "LinkedField",
                "name": "myAttendance",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibleStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormSubmission",
                    "kind": "LinkedField",
                    "name": "formSubmission",
                    "plural": false,
                    "selections": (v26/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v19/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sponsorshipDisplay",
                        "storageKey": null
                      },
                      (v28/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  (v29/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v30/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/),
                      (v12/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "EventTicketingTiersConnection",
                "kind": "LinkedField",
                "name": "eventTicketingTiers",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventTicketingTiersEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTicketingTier",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "availableFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "availableUntil",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ticketsRemaining",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minPerOrder",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maxPerOrder",
                            "storageKey": null
                          },
                          (v22/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "price",
                            "storageKey": null
                          },
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "includeTax",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "taxName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "taxPercentage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Form",
                "kind": "LinkedField",
                "name": "attendeeForm",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": "mobileTransformUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 576
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
                  },
                  {
                    "alias": "desktopTransformUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 200
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 368
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":368})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "eventOwner",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v22/*: any*/),
                      (v9/*: any*/),
                      (v28/*: any*/),
                      (v32/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v9/*: any*/),
                      (v30/*: any*/),
                      (v4/*: any*/),
                      (v12/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "attendeesByRelevance",
                "args": (v34/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
              },
              {
                "alias": "attendingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL"
                        ]
                      }
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
              },
              {
                "alias": "waitingCount",
                "args": [
                  (v36/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": "eventItemPresentations",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "CREATED_AT_ASC",
                      "ID_ASC"
                    ]
                  }
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v4/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "transform",
                                "value": {
                                  "dpr": 3,
                                  "h": 24,
                                  "w": 24
                                }
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "guestPresenterAvatarUrl",
                            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":24,\"w\":24})"
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "acceptingAttendance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventTicketOrder",
                "kind": "LinkedField",
                "name": "myTicketOrder",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "seoVenue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v3/*: any*/),
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanManage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventHostsConnection",
                "kind": "LinkedField",
                "name": "confirmedHosts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventHostsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventHost",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "host",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v22/*: any*/),
                                  (v9/*: any*/),
                                  (v28/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "type": "Guild",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v9/*: any*/),
                                  (v4/*: any*/),
                                  (v12/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "type": "User",
                                "abstractKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entryInstructions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine2",
                        "storageKey": null
                      },
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedAddress",
                        "storageKey": null
                      },
                      (v45/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v37/*: any*/),
                          (v31/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "transform",
                                "value": {
                                  "dpr": 3,
                                  "h": 48,
                                  "w": 48
                                }
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "guestPresenterAvatarUrl",
                            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":48,\"w\":48})"
                          },
                          (v40/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v34/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "equalTo": "PENDING"
                      }
                    }
                  }
                ],
                "concreteType": "EventHostsConnection",
                "kind": "LinkedField",
                "name": "eventHosts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventHostsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventHost",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hostType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "host",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v22/*: any*/),
                                  (v9/*: any*/),
                                  (v32/*: any*/)
                                ],
                                "type": "Guild",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/)
                                ],
                                "type": "User",
                                "abstractKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventHosts(filter:{\"status\":{\"equalTo\":\"PENDING\"}})"
              },
              {
                "alias": null,
                "args": [
                  (v33/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attendeeLimit",
                "storageKey": null
              },
              {
                "alias": "inPersonAttendees",
                "args": (v47/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v48/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:10)"
              },
              {
                "alias": "inPersonAttendees",
                "args": (v47/*: any*/),
                "filters": (v49/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogInPersonAttendees_event_inPersonAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "waitingAttendees",
                "args": (v50/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v48/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:10)"
              },
              {
                "alias": "waitingAttendees",
                "args": (v50/*: any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "EventScreenAttendeesDialogWaitingAttendees_event_waitingAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "onlineAttendees",
                "args": (v51/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v48/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:10)"
              },
              {
                "alias": "onlineAttendees",
                "args": (v51/*: any*/),
                "filters": (v49/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogOnlineAttendees_event_onlineAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "notAttending",
                "args": (v52/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v48/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"NOT_ATTENDING\"},first:10)"
              },
              {
                "alias": "notAttending",
                "args": (v52/*: any*/),
                "filters": (v49/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogNotAttending_event_notAttending",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "152b79efc61eeb609ce8a5a54087c5bb0503ee8555503d7a710b12b620f1443b",
    "metadata": {},
    "name": "EventAttendContentRemoveAttendanceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ced9e92b5fda5ad668d42711a51caeb6";

export default node;
